import { createIcon } from '../createIcon';

export const GaugeIconConfig = {
  name: 'GaugeIcon',
  height: 512,
  width: 512,
  svgPath: 'M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z',
  yOffset: 0,
  xOffset: 0
};

export const GaugeIcon = createIcon(GaugeIconConfig);

export default GaugeIcon;